var props = {
  name: {
    type: String,
    "default": ""
  },
  size: {
    type: String,
    "default": void 0
  },
  url: {
    type: [String, Array],
    "default": void 0
  },
  loadDefaultIcons: {
    type: Boolean,
    "default": true
  },
  onClick: Function
};

export default props;
//# sourceMappingURL=props.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-icons-vue/esm/svg-sprite/props/props.js
// module id = null
// module chunks = 